import React from 'react';
import { ShieldCheck, Zap, Leaf } from 'lucide-react';

// Compact compliance/trust badges shown near quote CTAs.
const BADGES = [
  { icon: Zap, label: 'ETL ready', sub: 'cRUus parts' },
  { icon: Leaf, label: 'Low GWP', sub: 'refrigerants' },
  { icon: ShieldCheck, label: '90 day', sub: 'rebuild warranty' },
];

export const TrustBadges = ({ variant = 'light', className = '' }) => {
  const dark = variant === 'dark';
  return (
    <div className={`flex flex-wrap gap-2 ${className}`} data-testid="trust-badges">
      {BADGES.map((b) => (
        <div
          key={b.label}
          className={`inline-flex items-center gap-2 rounded-lg px-3 py-2 border ${dark ? 'bg-white/5 border-white/15' : 'bg-[#F1F5F9] border-slate-200'}`}
          data-testid={`trust-badge-${b.label.toLowerCase()}`}
        >
          <b.icon className="h-4 w-4 text-[#CE8946] flex-shrink-0" />
          <span className="leading-tight">
            <span className={`block text-[11px] font-bold ${dark ? 'text-white' : 'text-[#003456]'}`}>{b.label}</span>
            <span className={`block text-[10px] ${dark ? 'text-white/50' : 'text-slate-500'}`}>{b.sub}</span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
